import { Component, HostListener, Injector, Signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AsyncPipe } from '@angular/common';

import { DocClickService } from './services/local/doc-click.service';
import { Observable } from 'rxjs';
import { Alert } from './models/alert.model';
import { AlertService } from './services/local/alert-service';
import { LoadingService } from './services/local/loading-service';
import { AlertPopupComponent } from './components/alert-popup/alert-popup.component';
import { LoadingOverlayComponent } from './components/loading-overlay/loading-overlay.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AsyncPipe, AlertPopupComponent, LoadingOverlayComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  static injector: Injector;
  alert$: Observable<Alert | null>;
  loading: Signal<boolean>;

  @HostListener('document:click', ['$event'])
  documentClick(event: any): void {
    this.clickService.documentClickedTarget.next(event.target);
  }

  constructor(private clickService: DocClickService, injector: Injector, alertService: AlertService, loadingService: LoadingService) {
    App.injector = injector;
    this.alert$ = alertService.alert$;
    this.loading = loadingService.loadingSgnl;
  }
}
